import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { QuoteModel } from "../../../../../../Wrap/Models/Models/Processes/Quote/QuoteModel";
import { processTypeEnum } from "../../Common/Resource/Contents";
import { QuoteInstructionDispatcher } from "./Variable";

export interface QuoteInstructionStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: QuoteModel;
}

export class QuoteInstructionStatic extends BaseStore<QuoteInstructionStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(QuoteInstructionDispatcher, (actionData) =>
            this.onQuoteInstructionStoreResponse(actionData)
        );
    }

    public getLastResult(): QuoteInstructionStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        //mock data need to be removed
        // const _data: QuoteModel = JSON.parse(JSON.stringify(this.getState().data));
        // if (_data?.PensionQuote?.DrawdownModel?.CrystallisationDetails) {
        //     _data.PensionQuote.DrawdownModel.CrystallisationDetails.AvailableToCrystallise = {
        //         Amount: 4000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.PensionQuote.DrawdownModel.CrystallisationDetails.CrystallisedValue = {
        //         Amount: 3000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.PensionQuote.DrawdownModel.CrystallisationDetails.UnCrystallisedValue = {
        //         Amount: 4000,
        //         Currency: CurrencyCode.GBP,
        //     };
        //     _data.PensionQuote.DrawdownModel.CrystallisationDetails.AvailableCash = {
        //         Amount: 2000,
        //         Currency: CurrencyCode.GBP,
        //     };
        // }
        // if (_data?.PensionQuote?.DrawdownModel) {
        //     _data.PensionQuote.DrawdownModel.CurrentPclsEntitlement = {
        //         Amount: 300,
        //         Currency: CurrencyCode.GBP,
        //     };
        // }

        // if (_data?.PensionQuote?.DrawdownModel) {
        //     _data.PensionQuote.DrawdownModel.LifetimeAllowance = {
        //         ChargeableCrystallisationPortion: {
        //             Amount: 500,
        //             Currency: CurrencyCode.GBP,
        //         },
        //         AvailablePersonalAllowance: {
        //             Amount: 500,
        //             Currency: CurrencyCode.GBP,
        //         },
        //         SlaBenefitsPriorTo2006: 5,
        //         TotalSlaUsed: 25,
        //         SlaPreviouslyCrystallised: 10,
        //         SlaUsedByProposedCrystallisation: 2,
        //     };

        //     if (_data?.PensionQuote?.DrawdownModel?.Income) {
        //         _data.PensionQuote.DrawdownModel.Income.MaximumAvailablePerPayment = {
        //             Amount: 20000,
        //             Currency: CurrencyCode.GBP,
        //         };
        //         _data.PensionQuote.DrawdownModel.Income.MaximumIncomePerPayment = {
        //             Amount: 20000,
        //             Currency: CurrencyCode.GBP,
        //         };
        //         _data.PensionQuote.DrawdownModel.Income.MaximumInitialIncomePayment = {
        //             Amount: 17500,
        //             Currency: CurrencyCode.GBP,
        //         };
        //     }

        //     if (_data?.PensionQuote?.DrawdownModel?.OneOffTaxableWithdrawalDetails) {
        //         _data.PensionQuote.DrawdownModel.OneOffTaxableWithdrawalDetails.MaximumGrossOneOffIncomePayment = {
        //             Amount: 16300,
        //             Currency: CurrencyCode.GBP,
        //         };
        //     }
        // }

        // if (_data?.PensionQuote?.PensionTransfers?.length > 0) {
        //     const result = calculateBasedOnStandardAlgorithm(processTypeEnum.Quote, _data?.PensionQuote);
        //     _data.PensionQuote.PensionTransfers = _data.PensionQuote.PensionTransfers.map((e) => {
        //         if (e?.IncomePaymentDetails?.DrawdownIncome?.AnnualIncome) {
        //             e.IncomePaymentDetails.DrawdownIncome.AnnualIncome.MaximumIncomePerPayment = {
        //                 Amount: result.MaximumIncomePerPayment,
        //                 Currency: CurrencyCode.GBP,
        //             };
        //         }
        //         if (e?.OneOffTaxableWithdrawalDetails) {
        //             e.OneOffTaxableWithdrawalDetails.MaximumGrossOneOffIncomePayment = {
        //                 Amount: result.MaximumGrossOneOffIncomePayment,
        //                 Currency: CurrencyCode.GBP,
        //             };
        //         }
        //         return e;
        //     });
        // }

        // return _data;

        return JSON.parse(JSON.stringify(this.getState().data));
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): QuoteInstructionStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onQuoteInstructionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType, isLoading: actionData.payload });
                break;
        }
    }
}
